import IsNullOrUndefined from "../utils/ObjectUtils";
import IsNullOrEmpty from "../utils/StringUtils";
import {CategoryType, FeatureType} from "../model/constants";

export const CameraShotUtility = {
    getCameraShot: (projectId, room, currentCamera, categories) =>
    {
        let categoriesSelectionString = '';
        const sectionSeparator = '.';
        const categorySelectionSeparator = '-';
        const shotCategories = [];

        if(IsNullOrUndefined(currentCamera)) return;

        const foundRoomCamera = room.cameras.find(c => c.id === currentCamera.id);

        if (!IsNullOrUndefined(foundRoomCamera) && !IsNullOrEmpty(foundRoomCamera.categories))
        {
            foundRoomCamera.categories.forEach(cameraCategory => {
                const foundCategory = categories.find(c => c.id === cameraCategory.id);
                const foundFeature = cameraCategory.features.find(f => f.id === foundCategory.selected_feature);
                if (!IsNullOrUndefined(foundCategory) && !IsNullOrUndefined(foundFeature) && foundCategory.selected_feature !== 0){
                    shotCategories.push(foundCategory);
                }
            });
        }

        shotCategories.sort(
            function (a, b) {
                if (a.selected_feature < b.selected_feature) {
                    return -1;
                }
                if (a.selected_feature > b.selected_feature) {
                    return 1;
                }

                return 0;
            });

        for (let countSelection = 0; countSelection < shotCategories.length; countSelection++) {
            categoriesSelectionString += shotCategories[countSelection].selected_feature;

            if (countSelection < shotCategories.length - 1) {
                categoriesSelectionString += categorySelectionSeparator;
            }
        }

        const currentCameraName = !IsNullOrUndefined(currentCamera.name) ? currentCamera.name : currentCamera.id;
        return projectId + sectionSeparator + currentCameraName + sectionSeparator + categoriesSelectionString;
    },

    updateCameraShots: (projectId, currentRoom, currentCamera, categories) =>
    {
        const currentRoomCameras = currentRoom.cameras;
        let currentRoomShots = [];

        currentRoomCameras.forEach((camera, index) => {
            let shot = CameraShotUtility.getCameraShot(projectId, currentRoom, camera, categories);
            currentRoomShots.push(shot);
        });

        return currentRoomShots;
    },

    findBestCameraForCategory: (focusedCategory, currentRoom, currentCamera, usePriority) => {

        if(focusedCategory !== null && currentCamera !== undefined) {
            let currentRoomCamerasRenderingCategory = [];
            let foundCamera = null;

            currentRoom.cameras.forEach(camera => {
                const cameraWithCategory = camera.categories.filter(c => c.id === focusedCategory.id)[0] || null;
                if (cameraWithCategory !== null) {
                    currentRoomCamerasRenderingCategory.push(camera);
                }
            });

            const currentCameraRenderingCategory = currentRoomCamerasRenderingCategory.filter(c => c.id === currentCamera.id)[0] || null;

            if (currentCameraRenderingCategory !== null)
            {
                return currentCamera;
            } else {
                return currentRoomCamerasRenderingCategory.length > 0 ? currentRoomCamerasRenderingCategory[0] : currentRoom.cameras[0];
            }
        }

        return currentRoom.cameras[0];
    },
    IsIconOnly: (rooms, improvementRules, category, feature) => {
        let isIconOnly = true;

        if (category.look_type === FeatureType.Default && category.features.length === 1) {
            return false;
        }

        // Check if the feature is used in any room camera
        const isFeatureUsed = rooms.some(room =>
            room.cameras.some(roomCamera =>
                roomCamera.categories.some(c =>
                    c.id === category.id &&
                    c.features.some(f => f.id === feature.id)
                )
            )
        );

        if (isFeatureUsed) {
            return false; // Directly return false if feature is used
        }

        // If category is an Improvement type, check improvement rules
        if (category.look_type === CategoryType.Improvement) {
            // Find all rules where this category is the origin
            const relatedRules = improvementRules.filter(rule => rule.originId === category.id);

            // Check if any of the linked destination categories are present in cameras
            const isLinkedToBaseCategory = relatedRules.some(rule =>
                rooms.some(room =>
                    room.cameras.some(roomCamera =>
                        roomCamera.categories.some(c => c.id === rule.destinationId)
                    )
                )
            );

            if (isLinkedToBaseCategory) {
                return false; // It is not icon-only if it is linked to a base category
            }
        }

        // If no conditions met, it is icon-only
        return isIconOnly;
    }
};
